import {TFunction} from '@wix/yoshi-flow-editor'

export const getSubmitButtonText = (
  messages: wix.events.form.FormMessages,
  ticketed: boolean,
  hasPolicies: boolean,
  waitlistOpen: boolean,
  t: TFunction,
  resolveCopy: (configured: string | undefined | null, translated: string) => string,
) => {
  if (hasPolicies) {
    return t('mobile.checkout.next')
  }

  if (ticketed) {
    return resolveCopy(
      messages.checkout.submitActionLabel,
      resolveCopy(messages.rsvp.submitActionLabel, t('mobile.checkout.next')),
    )
  }

  if (waitlistOpen) {
    return resolveCopy(messages.rsvp.submitActionLabel, t('detailsPage.registrationForm.waitlist.submitButtonText'))
  }

  return resolveCopy(messages.rsvp.submitActionLabel, t('oneButtonText'))
}
